import { takeLatest, put, call } from "redux-saga/effects";
import { CommonApiMethods } from "api/api-methods";
import BackendClient from "api/backend-client";
import { waitForLogin } from "store/auth/auth.saga";
import logger from "utils/logger";
import { editUsersAccessFailure, editUsersAccessSuccessful, getAllowedUsersFailure, getAllowedUsersSuccessful, getAllUsersFailure, getAllUsersSuccessful, getNotAllowedUsersFailure, getNotAllowedUsersSuccessful, removeUsersAccessFailure, removeUsersAccessSuccessful, UsersActionType, } from "./users.actions";
import { apiErrorHandler } from "store/global/global.saga";
function* getAllUsersSaga() {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const users = yield call([backendClient, CommonApiMethods.GetAllUsers]);
        yield put(getAllUsersSuccessful(users ?? []));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "all users list load failed");
        yield put(getAllUsersFailure());
    }
}
export function* fetchAllowedUsersSaga() {
    try {
        const backendClient = BackendClient.getInstance();
        const users = yield call([backendClient, CommonApiMethods.GetAllowedUsers]);
        yield put(getAllowedUsersSuccessful(users ?? []));
    }
    catch (e) {
        yield put(getAllowedUsersFailure());
        logger.error("fetching allowed users list failed");
    }
}
function* getAllowedUsersSaga() {
    try {
        yield call(waitForLogin);
        yield call(fetchAllowedUsersSaga);
    }
    catch (e) {
        yield call(apiErrorHandler, e, "get allowed users list load failed");
    }
}
function* getNotAllowedUsersSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const users = yield call([backendClient, CommonApiMethods.GetNotAllowedUsers], payload);
        yield put(getNotAllowedUsersSuccessful(users));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "get not allowed users list load failed");
        yield put(getNotAllowedUsersFailure());
    }
}
function* editUsersAccessSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const users = yield call([backendClient, CommonApiMethods.EditUsersAccess], payload);
        yield put(editUsersAccessSuccessful(users));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "edit user access failed");
        yield put(editUsersAccessFailure());
    }
}
function* removeUsersAccessSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield call([backendClient, CommonApiMethods.RemoveUsersAccess], payload);
        yield put(removeUsersAccessSuccessful(payload));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "remove user access failed");
        yield put(removeUsersAccessFailure());
    }
}
export default function* usersSaga() {
    yield takeLatest(UsersActionType.GET_ALL_USERS, getAllUsersSaga);
    yield takeLatest(UsersActionType.GET_ALLOWED_USERS, getAllowedUsersSaga);
    yield takeLatest(UsersActionType.GET_NOT_ALLOWED_USERS, getNotAllowedUsersSaga);
    yield takeLatest(UsersActionType.REMOVE_USERS_ACCESS, removeUsersAccessSaga);
    yield takeLatest(UsersActionType.EDIT_USERS_ACCESS, editUsersAccessSaga);
}
